export default "__VITE_ASSET__f26d30a4__"